<template>
  <div class="tw-relative">
    <quarantine-common
      v-if="selectedDomain"
      :tier="tierType"
      :tier_id="selectedDomain.id"
      class="tw-mb-6"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import QuarantineCommon from "@/views/Common/Quarantine";

import { TIER } from "@/constants";

export default {
  components: {
    QuarantineCommon,
  },
  data() {
    return {
      tierType: TIER.domains,
    };
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  computed: {
    ...mapGetters("authentication", ["selectedDomain"]),
  },

  async mounted() {
    this.setPageTitle(this.$t("Quarantine"));
    if (!this.selectedDomain) {
      this.$router.push("/logout");
    }
  },
};
</script>
